"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cordenons": {
    "248d6a4f": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "skipSearch": false
    }],
    "nogaredo": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9974eac0": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "skipSearch": false
    }],
    "romans": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3e9adead": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "skipSearch": false
    }],
    "sclavons": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c55f00ef": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "skipSearch": false
    }],
    "villa-d-arco": [{
      "hkey": "d3fbbd5b",
      "slug": "cordenons",
      "name": "Cordenons",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;